module.exports = __webpack_public_path__ + "img/max_deposit_ntd_desktop2.b1b9bca9.png";